import { idFlavor, N_DataOrigin_Url, N_SourceType } from "../../common";

export interface N_Publisher {
  name: string;
  sourceType: N_SourceType;
  logo: N_DataOrigin_Url | null;
}

export interface N_PublisherView extends N_Publisher {
  id: idFlavor<"Publisher">;
}

/** Media-owner id for JCDecaux placements (AU/NZ import pipeline). */
export const jcdPublisherId = "P-rD2wakcRVbPxkah6cfjh" as idFlavor<"Publisher">;
